import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const LOADING = 'loading'
export const SAVE = 'save'
export const UPDATED_QUOTA = 'updated quota'
export const VALIDATION_WANTED_COMPLETES = 'validation wanted completes'
export const ADD_AGENT = 'add agent'

export default {
  [PORTUGUESE]: {
    [LOADING]: 'Carregando',
    [SAVE]: 'Salvar',
    [UPDATED_QUOTA]: 'Cota atualizada',
    [VALIDATION_WANTED_COMPLETES]:
      'O número de completas desejadas deve ser maior que "0"',
    [ADD_AGENT]: 'Adicionar Agente',
  },

  [ENGLISH]: {
    [LOADING]: 'Loading',
    [SAVE]: 'Save',
    [UPDATED_QUOTA]: 'Updated quota',
    [VALIDATION_WANTED_COMPLETES]: 'Number of wanted completes must be greater than "0"',
    [ADD_AGENT]: 'Add Agent',
  },

  [SPANISH]: {
    [LOADING]: 'Cargando',
    [SAVE]: 'Salvar',
    [UPDATED_QUOTA]: 'Cuota actualizada',
    [VALIDATION_WANTED_COMPLETES]:
      'El número de búsquedas completas debe ser mayor que "0"',
    [ADD_AGENT]: 'Agregar Agente',
  },
}
